import React, { useEffect, useRef, useState } from 'react'
import { defaultDistrict, districtFilter } from '../../utils/helper';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar, getElementAtEvent, } from 'react-chartjs-2';
import { useNavigate } from 'react-router-dom';
import defaultInstance from '../../axiosHelper';
import { API_ENDPOINTS } from '../../utils/apiEndPoints';
import cloneDeep from 'lodash/cloneDeep'
import CustomHeader from '../header';
import DateFilterModal from './DateFilterModal';
import moment from 'moment';
import {
    Grid,
    CardContent,
} from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

import {
    ChartCard,
} from "../mainDashboard/Style/health-chart.style";


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const COLORS = [
    { background: 'rgba(255, 99, 132, 0.6)', border: 'rgba(255, 99, 132, 1)' },
    { background: 'rgba(54, 162, 235, 0.6)', border: 'rgba(54, 162, 235, 1)' },
    { background: 'rgba(255, 206, 86, 0.6)', border: 'rgba(255, 206, 86, 1)' },
    { background: 'rgba(157, 158, 158, 0.6)', border: 'rgba(75, 192, 192, 1)' },
    { background: 'rgba(153, 102, 255, 0.6)', border: 'rgba(153, 102, 255, 1)' },
    { background: 'rgba(255, 159, 64, 0.6)', border: 'rgba(255, 159, 64, 1)' },
    { background: 'rgba(199, 199, 199, 0.6)', border: 'rgba(199, 199, 199, 1)' },
    { background: 'rgba(83, 102, 255, 0.6)', border: 'rgba(83, 102, 255, 1)' },
    { background: 'rgba(0, 128, 128, 0.6)', border: 'rgba(0, 128, 128, 1)' },
    { background: 'rgba(128, 0, 128, 0.6)', border: 'rgba(128, 0, 128, 1)' },
    { background: 'rgba(128, 128, 0, 0.6)', border: 'rgba(128, 128, 0, 1)' },
    { background: 'rgba(255, 20, 147, 0.6)', border: 'rgba(255, 20, 147, 1)' },
    { background: 'rgba(0, 100, 0, 0.6)', border: 'rgba(0, 100, 0, 1)' },
    { background: 'rgba(70, 130, 180, 0.6)', border: 'rgba(70, 130, 180, 1)' },
    { background: 'rgba(210, 105, 30, 0.6)', border: 'rgba(210, 105, 30, 1)' },
    { background: 'rgba(244, 164, 96, 0.6)', border: 'rgba(244, 164, 96, 1)' },
];

const chartOptions = {
    responsive: true,
    plugins: {
        legend: { display: true, position: 'top' },
        title: { display: true },
        datalabels: {
            anchor: 'end',
            align: 'start',
            // rotation: -45,
            color: '#333',
            font: {
                weight: '700',
            },
            offset: -4,
        },
    },
    // scales: {
    //     x: {
    //         title: { display: true, text: 'Districts Name' },
    //         grid: { display: false },
    //     },
    //     y: {
    //         beginAtZero: true,
    //         title: { display: true, text: 'Data Captured' },
    //     },
    // },
    scales: {
        y: {
            beginAtZero: true,
            ticks: {
                color: '#000', // Black color for Y axis labels
                font: {
                    size: 14,   // Font size for Y axis labels
                    weight: 'bold'
                }
            },
            title: {
                display: true,
                text: 'Count',
                color: '#000',
                font: {
                    size: 16,
                    weight: 'bold'
                }
            }
        },
        x: {
            ticks: {
                color: '#000', // Black color for X axis labels
                font: {
                    size: 14,   // Font size for X axis labels
                    weight: 'bold'
                }
            },
            title: {
                display: true,
                text: 'Districts',
                color: '#000',
                font: {
                    size: 16,
                    weight: 'bold'
                }
            }
        }
    }
};

const DistrictScreening = () => {
    const navigate = useNavigate();

    const [districtChartData, setDistrictChartData] = useState(null);
    const [districtMainData, setDistrictMainData] = useState(null);

    const chartRef = useRef();
    const [isLoading, setIsLoading] = useState(true);
    const [filterData, setFilterData] = useState({ ...districtFilter() })
    const [showFilter, setShowFilter] = useState(false)

    const chartContainerStyle = { marginTop: 50 };

    const fetchCounts = async () => {
        const params = {
            fromDate: filterData?.from_date, toDate: filterData?.to_date
        }
        try {
            setIsLoading(true)
            const { data } = await defaultInstance.get(API_ENDPOINTS.NEW_COUNT_SUMMARY, { params: params });
            setIsLoading(false)
            if (data?.success) {
                const mergedData = mergeDistricts(data?.districts);
                const sortedData = mergedData.sort((a, b) => a?.district_count - b?.district_count);
                setDistrictMainData(data?.districts?.sort((a, b) => a?.district_count - b?.district_count))
                setDistrictChartData({
                    labels: sortedData?.map((d) => d.label) || [],
                    datasets: [
                        {
                            label: 'District base data captured',
                            data: sortedData?.map((d) => d.district_count === 0 ? null : d.district_count) || [],
                            backgroundColor: COLORS.map((c) => c.background),
                            borderColor: COLORS.map((c) => c.border),
                            borderWidth: 1,
                            minBarLength: 30
                        },
                    ],
                });
            }
        } catch (error) {
            setIsLoading(false)
            console.error('Error fetching counts:', error);
        }
    };

    const mergeDistricts = (data) => {
        const merged = cloneDeep(defaultDistrict);
        const districtMap = {
            'BISHNUPUR': 0, 'Bishnupur': 0, 'Bishnupur ': 0, ' BISHNUPUR': 0,
            'CHANDEL': 1, 'Chandel': 1, 'Chandel ': 1,
            'CHURACHANDPUR': 2, 'Churachandpur': 2,
            'IMPHAL EAST': 3, 'Imphal East': 3, 'Imphal east': 3, 'IMPHAL EAST ': 3,
            'IMPHAL WEST': 4, 'Imphal West': 4, 'IHMPHAL WEST': 4, 'Imphal West ': 4, 'IW': 4,
            'JIRIBAM': 5, 'Jiribam': 5, 'Jiribam ': 5, ' Jiribam ': 5,
            'KAKCHING': 6, 'Kakching': 6, 'Kakching ': 6, 'KAKCHING ': 6,
            'KAMJONG': 7, 'Kamjong': 7,
            'KANGPOKPI': 8, 'Kangpokpi': 8, 'kangpokpi': 8, 'Kangpokpi ': 8,
            'NONEY': 9, 'Noney': 9,
            'PHERZAWL': 10, 'Pherzawl': 10,
            'SENAPATI': 11, 'Senapati': 11, 'Senapati ': 11,
            'TAMENGLONG': 12, 'Tamenglong': 12,
            'TENGNOUPAL': 13, 'Tengnoupal': 13,
            'THOUBAL': 14, 'Thoubal': 14, 'Thoubal ': 14,
            'UKHRUL': 15, 'Ukhrul': 15
        };

        // Process each entry in the data array
        data.forEach(entry => {
            const districtIndex = districtMap[entry?.district];
            if (districtIndex !== undefined) {
                merged[districtIndex].district_count += entry.district_count;
            }
        });

        return merged;
    };

    const handleClick = (event) => {
        if (!chartRef.current) return;

        const elementAtEvent = getElementAtEvent(chartRef.current, event);

        if (elementAtEvent.length > 0) {
            const dataIndex = elementAtEvent[0]?.index;
            const clickedLabel = districtChartData?.labels[dataIndex];
            const clickedValue = districtChartData?.datasets[0]?.data[dataIndex];

            navigate(`/state-screening`, {
                state: {
                    action_type: 'district',
                    data: clickedLabel || '',
                    value: clickedValue || ''
                },
            });
        }
    };

    const updateValue = (key, value) => setFilterData((prevState) => ({ ...prevState, [key]: value }));

    useEffect(() => {
        fetchCounts();
    }, []);

    if (isLoading) {
        return (<div style={{ width: '98vw', height: '95vh', position: 'absolute', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            <img style={{ width: 50, height: 50 }} src='./loading.gif' alt='loading' />
        </div>)
    }

    const totalFemale = districtMainData?.reduce((sum, item) => sum + item?.female, 0);
    const totalMale = districtMainData?.reduce((sum, item) => sum + item?.male, 0);

    return (
        <div className="role-container">
            <CustomHeader
                hideHome
                heading='District Screening Overview'
                showFilter
                onFilterToggle={() => setShowFilter((prevState => !prevState))}
                extraComp={
                    <>
                        {filterData?.from_date && filterData?.to_date &&
                            <div style={{ color: '#000', fontSize: 15, marginRight: 10, fontWeight: 'bold' }}>
                                {`Filter Range: ${moment(filterData?.from_date, 'YYYY-MM-DD').format('DD MMM YYYY')} - ${moment(filterData?.to_date, 'YYYY-MM-DD').format('DD MMM YYYY')}`}
                            </div>
                        }
                    </>
                }
                extraMenuItem='Home'
                onExtraItemClick={() => navigate(-1)}
            />

            <div style={chartContainerStyle}>
                <Grid item xs={12} md={12} sx={{ width: '100%' }}>
                    <ChartCard>
                        <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <br />
                            {districtMainData?.length > 0 && (
                                <BarChart
                                    xAxis={[{ scaleType: "linear" }]}
                                    yAxis={[
                                        {
                                            width: 100,
                                            scaleType: "band",
                                            data: districtMainData?.map((item) => item?.district),
                                            tickLabelStyle: { fontSize: 12 },
                                        },
                                    ]}
                                    series={[
                                        {
                                            data: districtMainData.map((d) => d.male),
                                            label: `Male`,
                                            color: "#2196f3",
                                        },
                                        {
                                            data: districtMainData.map((d) => d.female),
                                            label: `Female`,
                                            color: "#ff9800",
                                        },
                                    ]}
                                    layout="horizontal"
                                    height={window.innerHeight - 300}
                                    slotProps={{
                                        legend: {
                                            direction: "horizontal",
                                            position: { horizontal: "center", vertical: "bottom" },
                                        },
                                    }}
                                />
                            )}
                            <div style={{ textAlign: "center", fontSize: "16px", marginTop: '15px' }}>
                                <strong>Total:</strong> {totalMale + totalFemale} &nbsp;&nbsp;
                                <strong>Female:</strong> {totalFemale} &nbsp;&nbsp;
                                <strong>Male:</strong> {totalMale}
                            </div>
                        </CardContent>
                    </ChartCard>
                </Grid>


            </div>
            {showFilter &&
                <DateFilterModal
                    visible={showFilter}
                    onDismiss={() => setShowFilter((prevState => !prevState))}
                    filterData={filterData}
                    updateValue={updateValue}
                    applyFilters={() => {
                        setShowFilter((prevState => !prevState))
                        fetchCounts();
                    }}
                    resetFilters={() => {
                        setShowFilter((prevState => !prevState))
                        setFilterData({ ...districtFilter() })
                        fetchCounts();
                    }}
                />
            }
        </div>
    )
}

export default DistrictScreening
